import messages from '@proj-airi/i18n/locales'

import { createI18n } from 'vue-i18n'

// 固定使用简体中文
export const i18n = createI18n({
  legacy: false,
  locale: 'zh-Hans',
  fallbackLocale: 'zh-Hans',
  messages,
})
